import * as React from 'react';
/**
 *
 * Original name: merge clips
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=43598%3A10924
 *
 */
export const MergeClipsLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M4 5.5V18h3.5v-1.5h-2v-4h2.942L7.37 13.592l1.07 1.05 2.838-2.894L8.44 8.872 7.372 9.925 8.432 11H5.5V7h2V5.5H4ZM19.502 18V5.5h-3.5V7h2v4.007h-2.415l1.071-1.092-1.071-1.05-2.837 2.894 2.839 2.876 1.067-1.053-1.06-1.075h2.406V16.5h-2V18h3.5ZM11 7H9V5.5h2V7ZM9 18h2v-1.5H9V18Zm5.5 0h-2v-1.5h2V18Zm-2-11h2V5.5h-2V7Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
